import React from "react";
import { Check, Gauge, Calendar } from "lucide-react";

function formatSeconds(seconds) {
  if (!seconds && seconds !== 0) return "--:--";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  if (h > 0) {
    return `${h}h ${m.toString().padStart(2, "0")}m ${s.toString().padStart(2, "0")}s`;
  }
  return `${m.toString().padStart(2, "0")}m ${s.toString().padStart(2, "0")}s`;
}

function formatDate(dateStr) {
  if (!dateStr) return "";
  try {
    const d = new Date(dateStr);
    return d.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (e) {
    return dateStr;
  }
}

export function StravaActivityCard({
  activity,
  isSelected = false,
  onSelect,
}) {
  if (!activity) return null;

  const distanceKm =
    activity.distance_km !== undefined
      ? Number(activity.distance_km).toFixed(2)
      : (activity.distance ? (activity.distance / 1000).toFixed(2) : "0.00");

  const duration =
    activity.moving_time_seconds ||
    activity.moving_time ||
    activity.elapsed_time_seconds ||
    activity.elapsed_time;

  const pace =
    activity.pace_min_km ||
    activity.pace ||
    "--:--";

  const speed =
    activity.average_speed_kmh !== undefined
      ? Number(activity.average_speed_kmh).toFixed(1)
      : null;

  return (
    <div
      onClick={() => onSelect && onSelect(activity)}
      className={`p-3.5 rounded-xl border transition-all cursor-pointer flex flex-col gap-2.5 ${
        isSelected
          ? "bg-[#FC4C02]/10 border-[#FC4C02] ring-1 ring-[#FC4C02]"
          : "bg-slate-900/60 border-slate-700/60 hover:border-slate-500 hover:bg-slate-800/60"
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-white truncate">
            {activity.name || "Corrida no Strava"}
          </h4>
          <div className="flex items-center gap-1.5 text-xs text-slate-400 mt-0.5">
            <Calendar className="w-3.5 h-3.5 flex-shrink-0 text-slate-500" />
            <span>{formatDate(activity.start_date_local || activity.start_date)}</span>
          </div>
        </div>

        <div
          className={`w-5 h-5 rounded-full flex items-center justify-center border transition-colors ${
            isSelected
              ? "bg-[#FC4C02] border-[#FC4C02] text-white"
              : "border-slate-600 bg-slate-800"
          }`}
        >
          {isSelected && <Check className="w-3.5 h-3.5 stroke-[3]" />}
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 pt-2 border-t border-slate-800/80 text-xs">
        <div>
          <span className="text-slate-400 block text-[10px] uppercase tracking-wider">
            Distância
          </span>
          <span className="font-bold text-white text-sm">
            {distanceKm} <span className="text-xs font-normal text-slate-400">km</span>
          </span>
        </div>

        <div>
          <span className="text-slate-400 block text-[10px] uppercase tracking-wider">
            Tempo
          </span>
          <span className="font-semibold text-white">
            {formatSeconds(duration)}
          </span>
        </div>

        <div>
          <span className="text-slate-400 block text-[10px] uppercase tracking-wider">
            Ritmo (Pace)
          </span>
          <span className="font-semibold text-white">
            {pace} <span className="text-[10px] text-slate-400">/km</span>
          </span>
        </div>
      </div>

      {speed && (
        <div className="flex items-center gap-1.5 text-[11px] text-slate-400">
          <Gauge className="w-3 h-3 text-[#FC4C02]" />
          <span>Velocidade média: <strong className="text-slate-200">{speed} km/h</strong></span>
        </div>
      )}
    </div>
  );
}

export default StravaActivityCard;
